// Module
var code = "<div class=\"clearfix\" ng-click=\"context.addFilter(data)\"> <div class=\"suggestion-inner clearfix\"> <div class=\"tag-result pull-left\" title=\"{{ data.value }}\"> {{ data.value }} </div> <div ng-if=\"data.count !== undefined\" class=\"count pull-right\">{{ data.count | readableNumber }} Posts</div> </div> </div> ";
// Exports
module.exports = code;